import React, { Fragment, useRef, useState } from "react";
import { CommonSvg } from "../SVG";
import WordWrapEllipse from "./WordWrapEllipse";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { useDownloadAssets } from "../../../context/DownloadAssetsContext";

// 'key validator design layout'
// '1 - just normal click with mouse'
// '2 - the case when the ctrl key and mouse is clicked at the time'
// '3 - the case when we click shift and click in which we will select all the previous '

const ImageGridSecondVersion = ({
  Data,
  EllipseActions,
  ClickHanlde,
  isValidViewsSection = false,
  Index = 0,
  isSelected,
  HandleSelect,
}) => {
  const lastKeyPressTime = useRef(0);
  const lastKey = useRef(null);
  const [loading, setloading] = useState(false)
  const [showPreview, setShowPreview] = useState(false);
  const { startDownload } = useDownloadAssets();
  // Identify the file type from the API's `assetType` (broad category) and
  // `assetFormat` (extension) keys.
  const assetFormat = (Data?.assetFormat || "").toLowerCase();
  const isImageAsset = isValidViewsSection
    ? Data?.isImage
    : Data?.assetType === "image";
  const isVideoAsset = isValidViewsSection
    ? Data?.isVideo
    : Data?.assetType === "video";
  const isPdfAsset = isValidViewsSection
    ? Data?.isPdf
    : Data?.assetType === "document" && assetFormat === "pdf";

  // Formats a browser can render directly in an <img>. Non-web image formats
  // (e.g. tif) fall back to the web-optimised view/thumbnail URL.
  const webImageFormats = ["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg", "avif"];

  // Source for the popup preview.
  const previewSrc = isValidViewsSection
    ? Data?.src
    : isImageAsset
      ? webImageFormats.includes(assetFormat)
        ? Data?.ogUrl
        : Data?.vifUrl || Data?.thumnnailUrl
      : Data?.ogUrl || Data?.thumnnailUrl;

  const closePreview = (e) => {
    e && e.stopPropagation();
    setShowPreview(false);
  };

  const handleMouseClick = (e) => {
    if (e.button === 0 && !e.ctrlKey && !e.shiftKey) {
      HandleSelect &&
        HandleSelect({
          Image: Data,
          Key: 1,
        });
      setShowPreview(true);
    }
    if (e.shiftKey && e.button === 0) {
      HandleSelect &&
        HandleSelect({
          Image: Data,
          Key: 3,
        });
    }

    if (e.ctrlKey && !e.shiftKey) {
      HandleSelect &&
        HandleSelect({
          Image: Data,
          Key: 2,
        });
    }

    if (e.altKey) {
    }
  };

  const handleDoubleClick = (e) => {
    if (e.shiftKey) {
    }
  };

  // Handle keyboard keys like Shift + Enter + detect double presses
  const handleKeyDown = (e) => {
    const now = Date.now();

    if (e.shiftKey && e.key === "Enter") {
    }

    if (e.ctrlKey && e.key === "Enter") {
    }

    if (e.altKey && e.key === "Enter") {
    }

    // Detect double key press (same key within 400ms)
    if (lastKey.current === e.key && now - lastKeyPressTime.current < 400) {
    }

    lastKey.current = e.key;
    lastKeyPressTime.current = now;
  };

  const downloadHandler = async (data) => {
    try {
      setloading(true)
      var _data = {
        fileId: [Data?.assetId],
        files: [Data],
      };
      const res = await startDownload(_data);

      setloading(false)
    } catch (err) {
      setloading(false)
      toast.error(err?.response?.message || "Something Went Wrong")
      console.error(err);
    }
  };

  return (
    <Fragment>
      <div
        key={Index}
        tabIndex={Index} // Makes the div focusable for key events
        className={`dam_common_hover ${isSelected && "dam_selected_design"}`}
        style={{ position: "relative" }}
        onClick={handleMouseClick} // Mouse click
        onDoubleClick={handleDoubleClick} // Mouse double click
        onKeyDown={handleKeyDown} // Keyboard + double key detection
      >
        {!isValidViewsSection ? (
          <div
            className="image_container_2nd_version_image_section"
            style={{ backgroundImage: `url(${Data?.thumnnailUrl})` }}
          />
        ) : (
          <div>
            {Data?.isImage ? (
              <div>
                <div
                  className="image_container_2nd_version_image_section"
                  style={{ backgroundImage: `url(${Data?.src})` }}
                />
              </div>
            ) : Data?.isVideo ? (
              <div>
                <video
                  src={Data?.src}
                  className="image_container_2nd_version_image_section"
                  style={{
                    width: "100%",
                  }}
                  controls
                />
              </div>
            ) : Data?.isPdf ? (
              <div>
                <iframe
                  src={Data?.src}
                  title={Data?.fileName}
                  className="image_container_2nd_version_image_section"
                  style={{
                    width: "100%",
                  }}
                />
              </div>
            ) : (
              <div>
                <div className="image_container_2nd_version_image_section d-flex justify-content-center align-items-center">
                  {Data?.fileName.split(".").pop().toUpperCase()}
                </div>
              </div>
            )}
          </div>
        )}

        <div
          style={{
            padding: "16px",
            display: "flex",
            justifyContent: "space-between",
            bottom: 0,
            width: "100%",
            borderRadius: "0px 0px 8px 8px",
            alignItems: "center",
          }}
        >
          <div className="d-flex gap-2 align-items-center">
            {isValidViewsSection ? (
              <div
                style={{
                  display: "flex",
                }}
              >
                {" "}
                {Data?.isImage
                  ? CommonSvg.imagePreviewIcons
                  : Data?.isPdf
                    ? CommonSvg.pdfPreviewIcons
                    : Data?.isVideo
                      ? CommonSvg.videoPreviewIcon
                      : CommonSvg.otherPreviewIcon}{" "}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                }}
              >
                {" "}
                {Data?.assetType === "document"
                  ? CommonSvg.pdfPreviewIcons
                  : Data?.assetType === "image"
                    ? CommonSvg?.imagePreviewIcons
                    : Data?.assetType === "video"
                      ? CommonSvg.videoPreviewIcon
                      : CommonSvg.otherPreviewIcon}
              </div>
            )}

            <div>
              <div className="image_container_2nd_version_image_section_2nd_header d-flex">
                <WordWrapEllipse
                  Text={Data?.assetName}
                  MaxWidth={"18ch"}
                  showTooltip={true}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
              margin: "-10px",
              borderRadius: "8px",
            }}
            className="DownloadButton"
            onClick={(e) => {
              e.stopPropagation();
              if (loading) {
                return
              }
              downloadHandler(); // ✅ no trailing comma
            }}
            onDoubleClick={(e) => e.stopPropagation()} // stop double-click bubbling
            onKeyDown={(e) => e.stopPropagation()} // stop key events bubbling
            role="button" // accessibility hint (optional)
            tabIndex={0} // make it keyboard focusable (optional)
            title="Download"
          >
            {
              loading ?
                <Spinner size="sm" />
                : EllipseActions
            }
          </div>
        </div>
      </div>

      {showPreview && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1050,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "32px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              backgroundColor: "#fff",
              borderRadius: "12px",
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 24px 60px rgba(0, 0, 0, 0.35)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "16px",
                padding: "14px 20px",
                borderBottom: "1px solid #ececec",
                flexShrink: 0,
              }}
            >
              <span
                style={{
                  fontWeight: 600,
                  fontSize: "15px",
                  color: "#1c1b1f",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={Data?.assetName || Data?.fileName}
              >
                {Data?.assetName || Data?.fileName}
              </span>
              <div
                onClick={closePreview}
                role="button"
                tabIndex={0}
                style={{
                  cursor: "pointer",
                  fontSize: "22px",
                  lineHeight: 1,
                  color: "#5f5f5f",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  flexShrink: 0,
                  transition: "background-color 0.15s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f0f0f0")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
                title="Close"
              >
                ×
              </div>
            </div>

            <div
              style={{
                padding: "16px",
                overflow: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 0,
                flex: 1,
                backgroundColor: isImageAsset ? "#f7f7f8" : "#fff",
              }}
            >
              {isImageAsset ? (
                <img
                  src={previewSrc}
                  alt={Data?.assetName || Data?.fileName}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "78vh",
                    objectFit: "contain",
                    borderRadius: "4px",
                  }}
                />
              ) : isVideoAsset ? (
                <video
                  src={previewSrc}
                  controls
                  autoPlay
                  poster={Data?.thumnnailUrl}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "78vh",
                    borderRadius: "4px",
                  }}
                />
              ) : isPdfAsset ? (
                <iframe
                  src={previewSrc}
                  title={Data?.assetName}
                  style={{
                    width: "80vw",
                    height: "78vh",
                    maxWidth: "100%",
                    border: "none",
                  }}
                />
              ) : (
                <div
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ padding: "48px 40px", gap: "12px" }}
                >
                  <span
                    style={{
                      fontSize: "28px",
                      fontWeight: 700,
                      color: "#753cb7",
                      letterSpacing: "1px",
                    }}
                  >
                    {(assetFormat || "FILE").toUpperCase()}
                  </span>
                  <span style={{ color: "#666" }}>
                    Preview is not available for this file type.
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ImageGridSecondVersion;
